import { useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";

const ModalChangeDeliveryDate = ({doc, minimizar, updateDate}) => {

    const [newDate, setNewDate] = useState(moment(doc.deliveryDate).format('YYYY-MM-DD'));

    const handleUpdateDate = () => {
         Swal.fire({
            title: "Ops!",
            text: "Esta seguro de querer actualizar la fecha de entrega estimada?",
            confirmButtonText:'Sí, estoy seguro',
            showCancelButton: true,
            cancelButtonText:'Cancelar',
            icon:'warning'
        })
        .then(res => {
            if(res.isConfirmed){
                updateDate(newDate);
                minimizar();
            }else{
                minimizar();
            }
        })
    }

    return <div className="modalFormDiv modalChangeDeliveryDate">
        <button className="minimizarBtn" onClick={minimizar}>X</button>
        <div className="inputGroup">
            <label>Nueva Fecha de Entrega Estimada</label>
            <input type="date" value={newDate} onChange={(e)=>setNewDate(e.target.value)}/>
        </div>
        <button className="modalFormBtn" onClick={handleUpdateDate}>GUARDAR</button>
    </div>

}

export default ModalChangeDeliveryDate;